export default {"src":"/_next/static/media/wishlist-heart.2d8856f2.svg","height":17,"width":19};